<template>
<a-alert class="notice" type="info" show-icon>
    <template #message v-if="onlyNew">此模块为新版服务费增加功能，仅有{{ splittingTime }}之后的数据</template>
    <template #message v-else>当前为{{ serviceVer ? '新版' : '旧版' }}服务费页面，仅展示{{splittingTime}}{{ serviceVer ? '之后' : '之前' }}的数据，若要查看{{ serviceVer ? '之前' : '之后' }}的数据，请点击上方的“切换{{ serviceVer ? '旧版' : '新版' }}”按钮切换至所需版本进行查询</template>
</a-alert>
</template>

<script>
import Data from '../../core/data';

export default {
    components: {},
    props: {
        onlyNew: { type: Boolean, default: false }
    },
    data() {
        return {
            serviceVer: Data.getServiceVersion(),
            splittingTime: '2023年11月20日'
        }
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>

<style lang='scss' scoped>
.notice {
    margin-bottom: 12px;
    ::v-deep .ant-alert-message {
        white-space: wrap!important;
    }
}
</style>